import React, { ReactNode } from 'react';
import {
    ColorDSD,
    ColorHex,
    IconLabelPlacement,
    IconTooltip,
    Police,
    Typography,
    Variant
} from '../../styles';
import { Box } from '@material-ui/core';

export interface TexteAvecInfoBulleProps {
    label: string | ReactNode;
    labelVariant?: Variant;
    labelPolice?: Police;
    labelColor?: ColorDSD | ColorHex;
    labelInfoBulle: string | ReactNode;
    labelInfoBullePlacement?: IconLabelPlacement;
    isSmallerLabelInfobulle?: boolean;
    labelHorsEcranInfoBulle: string;
    labelClass?: string;
    iconColor?: ColorDSD;
    iconColorCustom?: ColorHex;
    isCentreeDansContainer?: boolean;
    isLabelEtIconeCentres?: boolean;
    onToolTipActive?: () => void;
}

export const TexteAvecInfoBulle: React.FC<TexteAvecInfoBulleProps> = ({
    label,
    labelVariant = Variant.p,
    labelPolice = Police.normal,
    labelColor,
    labelInfoBulle,
    labelInfoBullePlacement,
    isSmallerLabelInfobulle,
    labelHorsEcranInfoBulle,
    labelClass,
    iconColor = ColorDSD.lightGraphite4,
    iconColorCustom,
    isCentreeDansContainer = false,
    isLabelEtIconeCentres = true,
    onToolTipActive
}) => {
    return (
        <Box
            display="flex"
            flexWrap="nowrap"
            alignItems={isLabelEtIconeCentres ? 'center' : 'flex-start'}
            justifyContent={isCentreeDansContainer ? 'center' : 'flex-start'}
        >
            <Typography
                variant={labelVariant}
                police={labelPolice}
                color={labelColor}
                marginBottom={'0rem'} // si on met une marge l'infobulle et le texte ne sont pas centrés
                className={labelClass}
            >
                {label}
            </Typography>
            <Box paddingLeft="0.5rem" />
            <IconTooltip
                iconName="alertes_rempli_information"
                iconSize="md"
                fill={iconColor}
                fillCustom={iconColorCustom}
                srOnlySuffix={labelHorsEcranInfoBulle}
                label={labelInfoBulle}
                placement={labelInfoBullePlacement}
                isSmallerTooltip={isSmallerLabelInfobulle}
                onActive={onToolTipActive}
            />
        </Box>
    );
};
